import { makeStyles } from "@fluentui/react-components";

export const useEllipsisTooltipStyles = makeStyles({
  tooltipMaxWidth: {
    maxWidth: "100%",
  },
});
